
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import PieChartFilterable from '@/components/reports-v3/components/filterables/PieChartFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import {getTableName} from '@/worker/db/sqlHelpers';

@Component({
	components: {
		PieChartFilterable,
	},
})
export default class CustomerUnAppliedAmountPieChart extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['customers'];
	}

	public filterIds: Array<
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf', 'customers', 'agents'];

	public pieDatas: Array<{ name: string; value: number }> = [];

	public get expensiveHook() {
		const { selectedAsOfDate, selectedAgents, selectedCustomers } = this;
		return JSON.stringify([
			selectedAsOfDate,
			selectedAgents,
			selectedCustomers,
		]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const table = getTableName('customerTrades');

		let customerFilter = '';
		if (this.selectedCustomers.length > 0) {
			const list = this.selectedCustomers.map((c) => `'${escapeStr(c)}'`).join(',');
			customerFilter = ` AND "CODE" IN (${list})`;
		}
		let agentFilter = '';
		if (this.selectedAgents.length > 0) {
			const list = this.selectedAgents.map((a) => `'${escapeStr(a)}'`).join(',');
			agentFilter = ` AND "AGENT" IN (${list})`;
		}

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['customerTrades']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const rows = await queryHead.rawQuery(`
			SELECT "DOCTYPE" as doc_type,
				SUM(TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE)) as unapplied_amt
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				AND "DOCTYPE" IN ('CN','CT','DP','PM','CF')
				${customerFilter}${agentFilter}
			GROUP BY "DOCTYPE"
		`);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.9);

		const nameMap: Record<string, string> = {
			CN: 'Credit Note',
			CT: 'Contra',
			DP: 'Deposit',
			PM: 'Payment',
			CF: 'Refund',
		};

		this.pieDatas = rows.map((row) => ({
			name: nameMap[row.doc_type] || row.doc_type,
			value: Number(row.unapplied_amt) || 0,
		}));

		this.generateLoadingText(1);
		this.saveHistory('pieDatas');
	}
}
